module.exports = __webpack_public_path__ + "img/bus-home-1.454e62af.jpg";